import { handleActions } from 'redux-actions';
import AdminState from 'types/admin';
import { setAdmin } from './actions';

const adminInitialState: AdminState = {
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  role: null,
  status: null,
  token: null,
};

const admin = handleActions(
  {
    [setAdmin as any]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
  adminInitialState
);

export default admin;
